export default "Prêt Vert ADEME et Prêt Économies d'Énergie Bpifrance pour financer la rénovation de vos immeubles tertiaires. Sans garantie sur les actifs. Cumulable avec CEE.";
